import { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withTheme(Component) {
  return props => {
    const theme = useTheme();
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      theme: theme
    }));
  };
}